<template>
	<div>
		<!-- 添加 -->
		<template>
			<Modal v-model="visible" title="添加公司" draggable class-name="vertical-center-modal" ok-text="添加" width="730"
				height="300" style="overflow: hidden;" @on-ok="ok" @on-cancel="cancel" :loading="loading">
				<Form ref="details" :model="details" :rules="ruleValidate" label-position="right" :label-width="100"
					style="width: 714px; height: 400px; margin: 0 auto; overflow-y: auto; padding-top: 20px;">

					<Row span="24">
						<Col span="10">
						<FormItem label="集团编号" prop="GroupCode">
							<Select v-model="details.GroupCode">
								<Option v-for="item in groupList" :key="item.Id" :value="item.GroupCode">
									{{item.GroupName}}
								</Option>
							</Select>
						</FormItem>
						</Col>
					</Row>

					<Row span="24">
						<Col span="10">
						<FormItem label="公司编号" prop="CompanyCode">
							<Input v-model="details.CompanyCode" placeholder="请输入公司编号"></Input>
						</FormItem>
						</Col>
						<Col span="10">
						<FormItem label="公司名称" prop="CompanyName">
							<Input v-model="details.CompanyName" placeholder="请输入公司名称"></Input>
						</FormItem>
						</Col>
					</Row>

					<Row span="24">
						<Col span="10">
						<FormItem label="联系电话" prop="Phone">
							<Input v-model="details.Phone" placeholder="请输入联系电话"></Input>
						</FormItem>
						</Col>
						<Col span="10">
						<FormItem label="地址" prop="Address">
							<Input v-model="details.Address" placeholder="请输入地址"></Input>
						</FormItem>
						</Col>
					</Row>
					<Row span="24">
						<Col span="10">
						<FormItem label="公司logo">
							<div class="demo-upload-list" v-for="(item, index) in uploadList" :key="index">
								<template>
									<img :src="item">
									<div class="demo-upload-list-cover">
										<Icon type="ios-trash-outline" @click.native="handleRemove(item)"></Icon>
									</div>
								</template>
							</div>
							<Upload v-if="uploadList.length == 0" ref="upload" :show-upload-list="false"
								:default-file-list="defaultList" :on-success="handleSuccess"
								:format="['jpg','jpeg','png']" :max-size="2048" :on-format-error="handleFormatError"
								:on-exceeded-size="handleMaxSize" :before-upload="handleBeforeUpload" :headers="headers"
								multiple type="drag" action="http://5g.hxpwr.com:7133/api/Basic/CompanyLogoUpload"
								style="display: inline-block;width:58px;">
								<div style="width: 58px;height:58px;line-height: 58px;">
									<Icon type="ios-camera" size="20"></Icon>
								</div>
							</Upload>
						</FormItem>

						</Col>
						<Col span="10">
						<FormItem label="公司标题">
							<Input v-model="details.TittleName" placeholder="公司标题"></Input>
						</FormItem>
						</Col>
					</Row>

				</Form>
			</Modal>
		</template>
	</div>
</template>

<script>
	import Cookies from "js-cookie";
	import {
		GetGrouplists
	} from "@/api/url_api.js";
	export default {
		props: {
			isShow: {
				type: Boolean,
				default: false
			},
			details: {
				type: Object,
				default: () => {
					return {}
				}
			}
		},
		data() {
			return {
				visible: false,
				formLeft: {},
				loading: true,

				groupList: [],

				ruleValidate: {
					GroupCode: [{
						required: true,
						message: '请选择集团',
						trigger: 'change'
					}],
					CompanyCode: [{
						required: true,
						message: '公司编号不能为空',
						trigger: 'blur'
					}],
					CompanyName: [{
						required: true,
						message: '公司名称不能为空',
						trigger: 'blur'
					}],
					Phone: [{
						required: true,
						message: '联系电话不能为空',
						trigger: 'blur'
					}],
					Address: [{
						required: true,
						message: '地址不能为空',
						trigger: 'blur'
					}]
				},
				defaultList: [{
						'name': 'a42bdcc1178e62b4694c830f028db5c0',
						'url': 'https://o5wwk8baw.qnssl.com/a42bdcc1178e62b4694c830f028db5c0/avatar'
					},
					{
						'name': 'bc7521e033abdd1e92222d733590f104',
						'url': 'https://o5wwk8baw.qnssl.com/bc7521e033abdd1e92222d733590f104/avatar'
					}
				],
				imgName: '',
				uploadList: [],
				headers: {
					"Authorization": Cookies.get('Token')
				},
			}
		},
		watch: {
			isShow(newValue, old) {
				this.visible = newValue;
				if (this.visible) {
					// 获取集团列表（不带分页）
					this.getGrouplists();
				}
			}
		},
		mounted() {

		},
		methods: {

			// 获取集团列表（不带分页）
			getGrouplists() {
				let _this = this;
				GetGrouplists().then(res => {
					if (res.Success) {
						_this.groupList = res.Data;
					}
				}).catch((err) => {
					console.log(err);
				});
			},

			ok(value) {
				let _this = this;
				_this.$refs.details.validate(valid => {
					if (valid) {
						if (_this.uploadList.length) {
							_this.details.CompanyLogo = '/' + _this.uploadList[0].split('/').slice(3).join('/');
						}
						_this.$emit("on-change", false, _this.details);
					} else {
						_this.$Message.error("请输入必填项");
						_this.loading = false;
						_this.$nextTick(() => {
							_this.loading = true;
						});
					}
				});

			},
			cancel(value) {
				this.$emit("on-change", this.visible)
			},

			handleRemove(file) {
				this.uploadList = [];
			},
			handleSuccess(res, file) {
				this.uploadList.push(res.Data);
			},
			handleFormatError(file) {
				this.$Notice.warning({
					title: '错误',
					desc: '请选择jpg, jpeg, png格式的图片'
				});
			},
			handleMaxSize(file) {
				this.$Notice.warning({
					title: '提示',
					desc: '图片最大不能超过2M'
				});
			},
			handleBeforeUpload() {
				const check = this.uploadList.length < 1;
				if (!check) {
					this.$Notice.warning({
						title: 'You can upload at most one photo.'
					});
				}
				return check;
			},
		},
	}
</script>

<style scoped="scoped">
	.demo-upload-list {
		display: inline-block;
		width: 60px;
		height: 60px;
		text-align: center;
		line-height: 60px;
		border: 1px solid transparent;
		border-radius: 4px;
		overflow: hidden;
		background: #fff;
		position: relative;
		box-shadow: 0 1px 1px rgba(0, 0, 0, .2);
		margin-right: 4px;
	}

	.demo-upload-list img {
		width: 100%;
		height: 100%;
	}

	.demo-upload-list-cover {
		display: none;
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		background: rgba(0, 0, 0, .6);
	}

	.demo-upload-list:hover .demo-upload-list-cover {
		display: block;
	}

	.demo-upload-list-cover i {
		color: #fff;
		font-size: 20px;
		cursor: pointer;
		margin: 0 2px;
	}
</style>
